// Module
var code = "<div class=\"container\"> <div class=\"content\"> <div class=\"row\"> <div class=\"col-md-12\"> <h3 class=\"page-title\">{{'DASHBOARD.ITEM_LOG.TITLE' | t}}</h3> </div> </div> </div> </div> <div class=\"job-search container\"> <eva-items-list show-id=\"true\" show-dates=\"true\"></eva-items-list> </div> ";
// Exports
module.exports = code;